import React from "react";

function SelectedWork() {
  return <h1 style={{ color: "#fff", marginTop: "200px" }}>SelectedWork</h1>;
}

export default SelectedWork;
